import React from 'react'
import { ShowHide } from '../../../../ui/record-display'
import BookingSchedule from './views'
import { groupBookingsByWeek } from './helper'

const BookingScheduleFromEnrolment = ({ sessions = {} }) => {
  if (!sessions.results) {
    return null
  }

  const { week1, week2 } = groupBookingsByWeek(sessions.results)

  if (week1.length === 0) {
    return null
  }

  return (
    <ShowHide label="approved enrolment schedule ">
      <BookingSchedule compact week1={week1} week2={week2} />
    </ShowHide>
  )
}

const BookingScheduleForCWA = ({ week1, week2 }) => <BookingSchedule week1={week1} week2={week2} />

export { BookingScheduleFromEnrolment, BookingScheduleForCWA, groupBookingsByWeek }



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/booking-schedules/index.js